const style = document.createElement("style");
const sheet = document.head.appendChild(style).sheet;
const mainNavs = document.querySelectorAll(`.navMain`) || [];

mainNavs.forEach((mainNav) => {
  const mainNavItems = mainNav.querySelectorAll('.navMain-item') || [];

  mainNavItems.forEach((mainNavItem) => {
    const navSubmenus = mainNavItem.querySelectorAll('.navSubmenu.level-2') || [];

    navSubmenus.forEach((navSubmenu) => {
      const navSubmenuItems = navSubmenu.querySelectorAll('.navSubmenu-item') || [];

      let level3Height = 0;

      navSubmenu.style.opacity = 0;
      navSubmenu.style.display = 'block';

      navSubmenuItems.forEach((navSubmenuItem) => {
        const navSubmenusLevel3 = navSubmenuItem.querySelectorAll('.navSubmenu.level-3') || [];

        navSubmenusLevel3.forEach((navSubmenuLevel3) => {
          navSubmenuLevel3.style.opacity = 0;
          navSubmenuLevel3.style.display = 'block';

          level3Height = Math.max(level3Height, navSubmenuLevel3.getBoundingClientRect().height - navSubmenuItem.offsetHeight);

          navSubmenuLevel3.style.display = '';
          navSubmenuLevel3.style.opacity = '';
        });
      });

      if (level3Height) {
        sheet.insertRule(`#${navSubmenu.id}:before {padding-top: ${level3Height}px;}`, sheet.cssRules.length);
      }

      navSubmenu.style.display = '';
      navSubmenu.style.opacity = '';
    });
  });
});

export default {};
